import Helper from "./Helper";

class Navigation {
  constructor(config = {}) {
    const { menuTogglerSelector, burgerSelector, backdropClass, searchToggle, searchToggleContainer } = config;
    this.body = document.querySelector("body");
    this.backdropClass = backdropClass || "menu-backdrop";
    this.menuToggler = document.querySelector(menuTogglerSelector);
    this.burger = document.querySelector(burgerSelector);
    this.searchButton = document.querySelector(searchToggle);
    this.searchToggleContainer = document.querySelector(searchToggleContainer);
    this.header = document.querySelector('.header');

    this.level1 = this.header.querySelectorAll('.menu__item--level-1 > .menu__link');
    this.submenuToggles = this.header.querySelectorAll('.menu__item--has-children:not(.menu__item--level-0)');

    this.mobileBackLinks = this.header.querySelectorAll('.menu__item-back');

    if (this.menuToggler) {
      this.createBackdrop();
      this.bindEvents();
      this.createFloater(this.header.querySelector(".menu--level-1"));
      this.setActiveItemsActive();
      this.addBackLink();
    }
  }

  bindEvents() {
    // meta events

    // burger
    if (this.burger) this.burger.addEventListener('click', (e) => {
      this.toggleMenu();
      e.stopPropagation();
      e.preventDefault();
    })

    // search
    if (this.searchButton) this.searchButton.addEventListener('click', (e) => {
      this.toggleSearchClasses();
      e.stopPropagation();
      e.preventDefault();
    });

    // mobile events 
    this.mobileBackLinks.forEach(mobileBackLink => {
      mobileBackLink.addEventListener('click', (e) => {
        console.log("back link click")
        const parent = mobileBackLink.closest('.menu__item--level-0');
        this.closeMenuChildren(parent);
      });
    });

    // desktop events

    if (this.menuToggler) this.menuToggler.addEventListener('click', (e) => {
      e.stopPropagation();
      e.preventDefault();
      this.toggleMenu();
    });

    this.submenuToggles.forEach(submenuToggle => {
      const innerLink = submenuToggle.querySelector('.menu__link');
      const mostInnerMenu = submenuToggle.querySelector('.menu');

      innerLink.addEventListener('click', (e) => {
        e.stopPropagation();
        e.preventDefault();

        console.log("clicked link", innerLink)

        const itemIsOpen = innerLink.classList.contains('active');


        // close siblings level 1
        if (innerLink.classList.contains('menu__link--level-1')) {
          console.log("clicked", submenuToggle);
          console.log("clicked parent", submenuToggle.parentElement.closest('.menu__item'));
          this.closeMenuChildren(submenuToggle.parentElement.closest('.menu__item'));

          // open level 1
          submenuToggle.classList.add('active');
          innerLink.classList.add('active');
          mostInnerMenu.classList.add('submenu-open');
        } else {
          if (!itemIsOpen) {
            submenuToggle.classList.add('active');
            innerLink.classList.add('active');
            mostInnerMenu.classList.add('submenu-open');
          } else {
            submenuToggle.classList.remove('active');
            innerLink.classList.remove('active');
            mostInnerMenu.classList.remove('submenu-open');
          }
        }
      });
    });

    if (this.level1) this.level1.forEach(menuItem => {
      menuItem.addEventListener('mouseenter', (e) => {
        e.stopPropagation();
        this.updateFloater(menuItem);
      });
      menuItem.addEventListener('mouseleave', (e) => {
        e.stopPropagation();
        this.updateFloater();
      });
    });

    // search events
  }

  addBackLink() {
    const currentPageMenuItem = this.header.querySelector('.menu__item--has-no-children.menu__item--active');
    if (!currentPageMenuItem) return; // nothing active
    let firstSibling = this.getFirstOfSiblings(currentPageMenuItem);
    const homeText = this.menuToggler.querySelector('.menu__link-text').innerText;

    if(!firstSibling) {
      this.appendBreadcrumb(homeText, NSContext.site.homeUrl);
      return;
    }

    // get first sibling of parent
    if (firstSibling == currentPageMenuItem) {
      firstSibling = this.getFirstOfSiblingsOfParentParent(currentPageMenuItem);

      if (!firstSibling || firstSibling.classList.contains('menu__item--level-1')) {
        this.appendBreadcrumb(homeText, NSContext.site.homeUrl);
        return;
      }
    }

    // remove this part if it is unwanted to go to the first lvl2 child
    // not first child to link to
    if (firstSibling.classList.contains('menu__item--has-children')) {
      this.appendBreadcrumb(homeText, NSContext.site.homeUrl);
      return;

      const firstChild = firstSibling.querySelector('.menu__item');

      if (firstChild != currentPageMenuItem) {
        const link = firstChild.querySelector('.menu__link');
        const itemText = firstSibling.querySelector('.menu__link-text');
        this.appendBreadcrumb(itemText.innerHTML, link.href);
        return;
      }

      // otherwise
      firstSibling = this.getFirstOfSiblingsOfParentParent(firstSibling);
      console.log(firstSibling);
    }

    if (firstSibling.classList.contains('menu__item--level-1') || firstSibling.classList.contains('menu__item--level-0')) {
      this.appendBreadcrumb(homeText, NSContext.site.homeUrl);
      return;
    }

    // otherwise set link
    const menuLink = firstSibling.querySelector('.menu__link');
    const menuText = firstSibling.querySelector('.menu__link-text');
    this.appendBreadcrumb(menuText.innerHTML, menuLink.href);
    
  }

  appendBreadcrumb(text, link) {
    let container = document.createElement('div');
    let anchor = document.createElement('a');
    let spanInner = document.createElement('span');
    let spanText = document.createElement('span');
    Helper.addClass(container, 'ns-header__breadcrump');
    Helper.addClass(anchor, 'ns-header__back-link');
    anchor.setAttribute('href', link); //add Link from parent of active menu-link
    spanText.innerHTML = text; //add Linktext from parent of active menu-link
    Helper.addClass(spanInner, 'menu-back-icon');
    spanInner.innerHTML = '<svg class="arrow-back" viewBox="0 0 48 48"><path fill-rule="evenodd" d="M13.7 30.4l1.4-1.4-4.3-4.3h25.274v-2H10.8l4.3-4.3-1.4-1.4L7 23.7z"></path></svg>';
    anchor.appendChild(spanInner);
    anchor.appendChild(spanText);
    container.appendChild(anchor); //build it!

    const title = document.querySelector('.ns-header');
    if (title) {
      title.prepend(container);
    }
  }

  getFirstOfSiblings(currentItem) {
    const parent = currentItem.parentElement.closest('.menu__item');
    const children = parent.querySelectorAll('.menu__item');

    if (children[0]) {
      return children[0];
    }

    return null;
  }

  getFirstOfSiblingsOfParentParent(currentItem) {
    const parent = currentItem.parentElement.closest('.menu__item');
    const parentParent = parent.parentElement.closest('.menu__item');
    const children = parentParent.querySelectorAll('.menu__item');

    if (children[0]) {
      return children[0];
    }

    return null;
  }

  closeMenuChildren(parent) {
    const childrenOfParent = parent.querySelectorAll('.menu__item--has-children');
    console.log("close children", childrenOfParent);
    console.log("close children parent", parent);
    childrenOfParent.forEach(child => {
      child.classList.remove('active');
      const menu = child.querySelector('.menu');
      // console.log("menu", menu)
      const link = child.querySelector('.menu__link.active');

      if (menu) menu.classList.remove('submenu-open');
      if (link) link.classList.remove('active');

    });
  }

  toggleMenu() {
    if (document.body.classList.contains('menu-open')) {
      this.closeMenu();
    } else {
      this.openMenu();
      this.updateFloater();

      this.closeSearch();
    }
  }

  openMenu() {
    document.body.classList.add('menu-open');
    this.menuToggler.classList.add('burger-active');
    this.burger.classList.add('burger-active');
  }

  closeMenu() {
    document.body.classList.remove('menu-open');
    this.menuToggler.classList.remove('burger-active');
    this.burger.classList.remove('burger-active');
  }

  openSearch() {
    this.closeMenu();
    this.menuToggler.classList.add('search-active');
    document.body.classList.add('search-active');
    document.body.classList.add('search-open');
  }

  closeSearch() {
    this.menuToggler.classList.remove('search-active');
    document.body.classList.remove('search-active');
    document.body.classList.remove('search-open');
  }

  // adds an extra class to all active menu__items so they're already open when menu toggled
  setActiveItemsActive() {
    const activeMenuItems = this.header.querySelectorAll('.menu__item--active, .menu__item--ancestor-active');
    activeMenuItems.forEach(activeMenuItem => {
      const link = activeMenuItem.querySelector('.menu__link');
      link.classList.add('active');
      activeMenuItem.classList.add('active');

      if (activeMenuItem.classList.contains('menu__item--ancestor-active') && link.nextElementSibling) {
        link.nextElementSibling.classList.add('submenu-open');
      }
    });

    // update floater to initial position
    this.updateFloater();
  }

  // set position of floater
  updateFloater(target, visible = true) {
    const elementToFloatTo = this.header.querySelector('.menu__link--level-1.active');

    if (!visible || !elementToFloatTo) {
      this.floater.classList.remove('is-visible');
      this.floater.style.left = '-100%';
      return;
    }

    if (target) {
      this.floater.style.left = `${target.getBoundingClientRect().left}px`;
      this.floater.classList.add('is-visible');
      return;
    }

    if (elementToFloatTo) {
      this.floater.style.left = `${elementToFloatTo.getBoundingClientRect().left}px`;
      this.floater.classList.add('is-visible');
      return;
    }
  }

  // create floater
  createFloater(parent) {
    if (!parent) return;

    this.floater = document.createElement("i");
    this.floater.classList.add("floating-hover");
    parent.appendChild(this.floater);
  }

  // create backdrop div. why is this done via JS ??
  createBackdrop() {
    const backdrop = document.querySelector(`.${this.backdropClass}`);
    if (!!backdrop) return;

    const div = document.createElement('div');
    div.classList.add(this.backdropClass);
    document.body.appendChild(div);
    this.backdrop = div;
  }

  // failsafe everything
  toggleSearchClasses() {
    if (document.body.classList.contains('search-open')) {
      document.body.classList.remove('search-open');
      if (this.searchToggleContainer) this.searchToggleContainer.classList.remove('active'); // hide search form
      if (this.menuToggler) this.menuToggler.classList.remove('search-active');
      if (this.burger) this.burger.classList.remove('search-active');
    } else {
      document.body.classList.add('search-open');
      if (this.searchToggleContainer) this.searchToggleContainer.classList.add('active'); // hide search form
      if (this.menuToggler) this.menuToggler.classList.add('search-active');
      if (this.burger) this.burger.classList.add('search-active');
    }
  }
}

export default Navigation;
